import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {genders} from "../../../../types/custom-types";

@Component({
    selector: 'app-person-form',
    templateUrl: './person-form.component.html',
    standalone: false
})
export class PersonFormComponent implements OnInit {

  @Input('apiErrors') apiErrors: Map<string, string>
  @Input('eventForm') eventForm: FormGroup

  readonly genders: { code: string, description: string }[] = genders();
  maxBirthDate: Date = new Date()

  constructor() {
  }

  ngOnInit(): void {
  }
}
